import type { RootState } from '../../configureStore';

const selectParserErrorsState = (state: RootState) => state.parserErrors;

export const selectParserErrors = (state: RootState) => selectParserErrorsState(state).items;
export const selectParserErrorsTotal = (state: RootState) => selectParserErrorsState(state).total;
export const selectParserErrorsPage = (state: RootState) => selectParserErrorsState(state).page;
export const selectParserErrorsPageSize = (state: RootState) =>
  selectParserErrorsState(state).pageSize;
export const selectParserErrorsLoading = (state: RootState) =>
  selectParserErrorsState(state).loading;
export const selectParserErrorDeletingId = (state: RootState) =>
  selectParserErrorsState(state).deletingId;
export const selectParserErrorsError = (state: RootState) => selectParserErrorsState(state).error;
